import React from 'react';
import PropTypes from 'prop-types';
import SourceIcon from '../../../shared/marketing/SourceIcon';
import { TRACKING_LINKS_COLUMNS } from '../constants/columnsConfig';

const LINK_TYPE_LABEL = { email: 'Email', social: 'Social', paid: 'Ad', qr: 'QR', other: 'Other' };
const fmtInt = (n) => (Number(n) || 0).toLocaleString();
const fmtPct = (n) => `${(Number(n) || 0).toFixed(2)}%`;
const fmtRev = (n) => `$${(Number(n) || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

const dash = (v) => (v == null || v === '' ? '—' : v);

const CELLS = {
  name: (r) => (
    <span className="tl-source">
      <SourceIcon type={(r.link_type && LINK_TYPE_LABEL[r.link_type]) || 'Other'} />
      <span>{r.name || '(unnamed)'}</span>
    </span>
  ),
  event: (r) => (r.event_insights_path
    ? <a href={r.event_insights_path}>{r.event_name}</a>
    : <span>{r.event_name}</span>),
  type: (r) => (r.link_type && LINK_TYPE_LABEL[r.link_type]) || 'Other',
  source: (r) => dash(r.utm_source),
  medium: (r) => dash(r.utm_medium),
  campaign: (r) => dash(r.utm_campaign),
  visits: (r) => fmtInt(r.visits),
  orders: (r) => fmtInt(r.orders),
  tickets: (r) => fmtInt(r.tickets),
  conversion_rate: (r) => fmtPct(r.conversion_rate),
  revenue: (r) => fmtRev(r.revenue),
};
const LABELS = Object.fromEntries(TRACKING_LINKS_COLUMNS.map((c) => [c.id, c.label]));
const NUMERIC_COLUMNS = new Set(['visits', 'orders', 'tickets', 'conversion_rate', 'revenue']);

const TrackingLinksTable = ({ rows, visibleColumnIds }) => {
  const cols = visibleColumnIds.filter((id) => CELLS[id]);
  if (!rows.length) return <p className="tl-empty">No trackable links found.</p>;
  return (
    <div className="tl-table-scroll">
      <table className="tl-table figma-table">
        <thead>
          <tr>{cols.map((id) => <th key={id} className={NUMERIC_COLUMNS.has(id) ? 'tl-num' : undefined}>{LABELS[id]}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.trackable_link_id}>
              {cols.map((id) => (
                <td key={id} className={NUMERIC_COLUMNS.has(id) ? 'tl-num' : undefined}>{CELLS[id](r)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

TrackingLinksTable.propTypes = {
  rows: PropTypes.array.isRequired,
  visibleColumnIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default TrackingLinksTable;
